module.exports = __webpack_public_path__ + "static/media/spot.7a0acfd6.svg";